'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

exports.default = (0, _immutable.Record)({
  quickReplies: (0, _immutable.OrderedSet)(),
  allowMultiSelect: false,
  allowUserInput: false
}, 'QuickReply');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/records/QuickReply.js
// module id = 579
// module chunks = 2 3